/*
 *
 * EloquaVerify actions
 *
 */
import { VERIFY_ELOQUA } from './constants';
import { defineAction } from 'utils/action-helper';

export const verifyEloqua = {
  start: ({ payload }) => defineAction({ type: VERIFY_ELOQUA.START, payload }),
  success: () => defineAction({ type: VERIFY_ELOQUA.SUCCESS }),
  error: ({ error }) =>
    defineAction({
      type: VERIFY_ELOQUA.ERROR,
      payload: {
        error,
      },
    }),
};
